import { anodum } from '@yola/ws-sdk';

const getElementAttributesFromString = (string) => {
  try {
    const element = anodum.parseElementFromString(string);

    return [...element.attributes].reduce(
      (acc, attr) => ({
        ...acc,
        [attr.name]: attr.value,
      }),
      {}
    );
  } catch (error) {
    return {};
  }
};

export default getElementAttributesFromString;
